import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'ar_XD',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  '78e93e55-5a10-4ce0-9020-8c940595bd73',
  'rtl'
);
